import { render, staticRenderFns } from "./HasLivingRoom.vue?vue&type=template&id=5fb74d84&"
import script from "./HasLivingRoom.vue?vue&type=script&lang=ts&"
export * from "./HasLivingRoom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports